import sessionStore from '@/stores/session';
import loadScript from '@/helpers/load-script';

type GoogleMapsCallback = () => void;

const callbackStack: GoogleMapsCallback[] = [];
const callbackFunctionName = 'cGoogleMapsInitMap';
let isMapsAPILoaded = false;

declare global {
  interface Window {
    [callbackFunctionName]: GoogleMapsCallback;
  }
}

window[callbackFunctionName] = (): void => {
  isMapsAPILoaded = true;
  callbackStack.forEach(callback => callback());
  callbackStack.length = 0;
};

/**
 * This function checks whether the Map API has already been loaded once.
 */
export default function googleMapsApi(): Promise<typeof google.maps> {
  return new Promise((resolve) => {
    const useSessionStore = sessionStore();
    const apiKey = useSessionStore.apiKeys.googleApiKey;
    const callback = () => {
      resolve(window.google.maps);
    };

    if (!apiKey) {
      throw new Error('No Google Maps API key provided.');
    }

    if (isMapsAPILoaded) {
      callback();
    } else {
      const url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&libraries=places&callback=${callbackFunctionName}`;

      callbackStack.push(callback);

      loadScript(url, undefined, { async: true });
    }
  });
}
